import React from 'react';
import styled from 'styled-components';
import Text from '../components/Text';
import Box from '../components/layout/Box';

const StyledDiv = styled.div``;

const CardSection = ({ title, subtitle, after, children, className }) => (
  <StyledDiv
    className={`d-flex mb-5 flex-grow-1 flex-shrink-1 flex-column ${className}`}
    style={{
      minWidth: 0,
    }}
  >
    {title && (
      <Box
        className="align-items-center mb-3 pb-3"
        style={{
          borderBottom: '2px solid #e7e7e7',
        }}
      >
        <Box className="flex-grow-1 flex-shrink-1 flex-column">
          {title && <Text variant="sectionTitle">{title}</Text>}
          {subtitle && (
            <Text className="mt-1" variant="sectionSubtitle">
              {subtitle}
            </Text>
          )}
        </Box>

        {after && <Box className="flex-shrink-0">{after}</Box>}
      </Box>
    )}
    {children}
  </StyledDiv>
);

CardSection.defaultProps = {
  title: undefined,
};

export default CardSection;
